import { escapeDoubleQuotes } from 'swag-common/utils/strings';
export const generateProductName = (name, count, index) => {
  const escapedProductName = escapeDoubleQuotes(name);
  const numericSuffix = count > 1 ? ' ' + (index + 1) : '';
  return `${escapedProductName}${numericSuffix}`;
};